// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  The info-pratiques \`description\` HTML is authored with presentation
  hints baked in: <img width="1024" height="408" style="max-width:320px">.
  Those HTML width/height attributes pin the rendered box to a fixed size
  (squashing the aspect ratio), and the inline max-width only clamps the
  width — leaving the height untouched so the image stretches.

  Reset the HTML hints to \`auto\` so the intrinsic ratio is honoured, then
  cap both dimensions. height/width:auto must come AFTER the UA rules that
  map the width/height attributes, so they need the same specificity but
  later source order — this stylesheet loads after the UA stylesheet.
  The inline \`max-width:320px\` beats our .description img max-width, so we
  override it with !important to let the image use the full container width
  on narrow viewports (and still respect max-height below).
*/
.H1__EUYGaHN2sNU9veZn img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
  max-width: 100% !important;
  max-height: 60vh;
  object-fit: contain;
  border-radius: 8px;
}

.H1__EUYGaHN2sNU9veZn p,
.H1__EUYGaHN2sNU9veZn ul,
.H1__EUYGaHN2sNU9veZn ol,
.H1__EUYGaHN2sNU9veZn h1,
.H1__EUYGaHN2sNU9veZn h2,
.H1__EUYGaHN2sNU9veZn h3,
.H1__EUYGaHN2sNU9veZn h4,
.H1__EUYGaHN2sNU9veZn h5,
.H1__EUYGaHN2sNU9veZn h6 {
  margin-block-start: 0.25em !important;
  margin-block-end: 0.25em !important;
}

/* Reduce the height of empty line breaks left by the editor */
.H1__EUYGaHN2sNU9veZn :is(p, h1, h2, h3, h4, h5, h6):empty, 
.H1__EUYGaHN2sNU9veZn :is(p, h1, h2, h3, h4, h5, h6):has(> br:only-child) {
  margin: 0 !important;
  line-height: 0.2;
}

/* Prevent huge spaces at the top and bottom of the description */
.H1__EUYGaHN2sNU9veZn > *:first-child {
  margin-block-start: 0 !important;
}
.H1__EUYGaHN2sNU9veZn > *:last-child {
  margin-block-end: 0 !important;
}

/* Completely hide accidental line breaks at the very beginning of the text */
.H1__EUYGaHN2sNU9veZn > :is(p, h1, h2, h3, h4, h5, h6):empty:first-child,
.H1__EUYGaHN2sNU9veZn > :is(p, h1, h2, h3, h4, h5, h6):has(> br:only-child):first-child,
.H1__EUYGaHN2sNU9veZn > br:first-child {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./web/static/pages/infos-pratiques.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;CAcC;AACD;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA,8DAA8D;AAC9D;;EAEE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;;AAEA,6EAA6E;AAC7E;;;EAGE,wBAAwB;AAC1B","sourcesContent":["/*\n  The info-pratiques `description` HTML is authored with presentation\n  hints baked in: <img width=\"1024\" height=\"408\" style=\"max-width:320px\">.\n  Those HTML width/height attributes pin the rendered box to a fixed size\n  (squashing the aspect ratio), and the inline max-width only clamps the\n  width — leaving the height untouched so the image stretches.\n\n  Reset the HTML hints to `auto` so the intrinsic ratio is honoured, then\n  cap both dimensions. height/width:auto must come AFTER the UA rules that\n  map the width/height attributes, so they need the same specificity but\n  later source order — this stylesheet loads after the UA stylesheet.\n  The inline `max-width:320px` beats our .description img max-width, so we\n  override it with !important to let the image use the full container width\n  on narrow viewports (and still respect max-height below).\n*/\n.description img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: auto;\n  height: auto;\n  max-width: 100% !important;\n  max-height: 60vh;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.description p,\n.description ul,\n.description ol,\n.description h1,\n.description h2,\n.description h3,\n.description h4,\n.description h5,\n.description h6 {\n  margin-block-start: 0.25em !important;\n  margin-block-end: 0.25em !important;\n}\n\n/* Reduce the height of empty line breaks left by the editor */\n.description :is(p, h1, h2, h3, h4, h5, h6):empty, \n.description :is(p, h1, h2, h3, h4, h5, h6):has(> br:only-child) {\n  margin: 0 !important;\n  line-height: 0.2;\n}\n\n/* Prevent huge spaces at the top and bottom of the description */\n.description > *:first-child {\n  margin-block-start: 0 !important;\n}\n.description > *:last-child {\n  margin-block-end: 0 !important;\n}\n\n/* Completely hide accidental line breaks at the very beginning of the text */\n.description > :is(p, h1, h2, h3, h4, h5, h6):empty:first-child,\n.description > :is(p, h1, h2, h3, h4, h5, h6):has(> br:only-child):first-child,\n.description > br:first-child {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `H1__EUYGaHN2sNU9veZn`
};
export default ___CSS_LOADER_EXPORT___;
